import { div, Drawer } from "antd";
import { Link, useNavigate } from "react-router-dom";
import styles from "./Headersidebar.module.css";
import { useState } from "react";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { auto } from "@popperjs/core";
import useProfileData from "../../hooks/useProfileData";

const HeaderSidebar = ({ onClose, open }) => {
  const navigate = useNavigate();
  const { profileData } = useProfileData();
  const [placement, setPlacement] = useState("left");
  const [isAttendanceOpen, setIsAttendanceOpen] = useState(false);
  const [isDarOpen, setIsDarOpen] = useState(false);
  const [isKraOpen, setKraOpen] = useState(false);
  const [isReportOpen, setReportOpen] = useState(false);
  const [isQuotOpen, setIsQuotOpen] = useState(false);
  const [isCustomerOpen, setIsCustomerOpen] = useState(false);
  const [isHrOpen, setIsHrOpen] = useState(false);
  const [isDirectorOpen, setIsDirectorOpen] = useState(false);
  const [isAdminOpen, setIsAdminOpen] = useState(false);
  const [isTargetAndIncentiveOpen, setIsTargetAndIncentiveOpen] =
    useState(false);
  const [openQuotation, setOpenQuotation] = useState(false);
  const [isOpenProject, setIsOpenProject] = useState(false);
  const [isOpenProjectActivity, setOpenProjectActivity] = useState(false);
  const [isOpenTraining, setIsOpenTraining] = useState(false);
  const [isReviewOpen, setReviewOpen] = useState(false);
  const [isReimbursementOpen, setIsReimbursementOpen] = useState(false);
  const [isLeaveDetailOpen, setLeaveDetailOpen] = useState(false);
  const [isAppraisalOpen, setAppraisalOpen] = useState(false);
  const [isHRTrainingmoduleOpen, setIsHrTrainingmoduleOpen] = useState(false);
  const [ishRreviewModuleOpen, setIshRreviModuleOpen] = useState(false);
  const [isCustomerMasterOpen, setCustomerMasterOpen] = useState(false);
  const [isOrderopen, setIsOrderOpen] = useState(false);
  const [isItEquipmentOpen, setEquipmentOpen] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData.userRole;

  const openAttendanceDropdown = () => {
    setIsAttendanceOpen((prev) => !prev);
  };

  const openOrderDropdown = () => {
    setIsOrderOpen((prev) => !prev);
  };
  const openCustomerMasterDropdown = () => {
    setCustomerMasterOpen((prev) => !prev);
  };
  const openQuotationDropdown = () => {
    setOpenQuotation((prev) => !prev);
  };

  const openDarDropdown = () => {
    setIsDarOpen((prev) => !prev);
  };

  const openQuotDropdown = () => {
    setIsQuotOpen((prev) => !prev);
  };

  const openReportDropdown = () => {
    setReportOpen((prev) => !prev);
  };

  const openHrDropdown = () => {
    setIsHrOpen((prev) => !prev);
  };

  const openCustomerDropdown = () => {
    setIsCustomerOpen((prev) => !prev);
  };

  const openDirectorDropdown = () => {
    setIsDirectorOpen((prev) => !prev);
  };

  const openAdminDropdown = () => {
    setIsAdminOpen((prev) => !prev);
  };

  const openTargetAndIncentiveDropdown = () => {
    setIsTargetAndIncentiveOpen((prev) => !prev);
  };

  const openProjectDropdown = () => {
    setIsOpenProject((prev) => !prev);
  };

  const openProjectActivityDropdown = () => {
    setOpenProjectActivity((prev) => !prev);
  };
  const openTrainingDropdown = () => {
    setIsOpenTraining((prev) => !prev);
  };
  const openKraDropdown = () => {
    setKraOpen((prev) => !prev);
  };

  const openReviewDropdown = () => {
    setReviewOpen((prev) => !prev);
  };

  const openReimbursementDropdown = () => {
    setIsReimbursementOpen((prev) => !prev);
  };

  const openLeaveDetails = () => {
    setLeaveDetailOpen((prev) => !prev);
  };
  const openAppraisalDropdown = () => {
    setAppraisalOpen((prev) => !prev);
  };

  const openHRTrainingModuleDropdown = () => {
    setIsHrTrainingmoduleOpen((prev) => !prev);
  };
  const openHrReviewModelDropdown = () => {
    setIshRreviModuleOpen((prev) => !prev);
  };
  const handleMenuClick = () => {
    onClose();
  };

  const probationInfo = JSON.parse(localStorage.getItem("probationInfo"));
 
  let attendanceLinks = [
    {
      href: "/Attendance",
      text: "Attendance List",
    },
    {
      href: "/Attendance/MarkAttendance",
      text: "Mark Attendance",
    },
    {
      href: "/Attendance/AttendanceList",
      text: "Attendance Report",
    },
    {
      href: "/Attendance/RequestLeave",
      text: "Request Leave",
    },
    {
      href: "/Attendance/LeaveHistory",
      text: "Leave History",
    },
  ];

  const projectLinks = [
    {
      text: "Manage Project Type",
      href: "/Projects/ManageProjectType",
    },
    {
      text: "Manage Project",
      href: "/Projects/ManageProject",
    },
    {
      text: "Project Allocate",
      href: "/Projects/ProjectAllocation",
    },
    {
      text: "Approve Project Activity",
      href: "/Projects/ApprovedActivity",
    },
  ];
  const userProjectLinks = [
    {
      text: "Assinged Projects",
      href: "/Projects/AssignedProject",
    },
    {
      text: "Activity Status",
      href: "/Projects/ActivityStatus",
    },
  ];

  const reviewFormLink = profileData.appraisalFormId
    ? profileData.appraisalFormId === 1
      ? `Appraisal/1?EmpId=${profileData.loginId}`
      : profileData.appraisalFormId === 2
      ? `Appraisal/2?EmpId=${profileData.loginId}`
      : profileData.appraisalFormId === 3
      ? `Appraisal/3?EmpId=${profileData.loginId}`
      : profileData.appraisalFormId === 5
      ? `Appraisal/5?EmpId=${profileData.loginId}`
      : "Appraisal/Not-Found"
    : "Appraisal/Not-Found";

  return (
    <Drawer
  //   placement={placement}
  // width={300}
  // onClose={onClose}
  // open={open}
  // closable={true}             
  // title={null}                 
  // closeIcon={<span style={{ color: '#fff', fontSize: '24px' }}>×</span>}
    placement={placement} width={300} onClose={onClose} open={open}
    afterOpenChange={(visible) => {
      if (visible) {
        window.dispatchEvent(new Event("resize"));
      }
    }}
    >
      <ul className={styles.drawerMenu}>
        <li>
          <Link to="/Dashboard">Dashboard</Link>
        </li>
        <li>
          <Link to="/HumanResource" onClick={handleMenuClick}>
            Human Resource
          </Link>
        </li>
        <li>
          <Link to="/KnowledgeShare" onClick={handleMenuClick}>
            Knowledge Sharing
          </Link>
        </li>
        <li>
          <Link to="/HolidayList" onClick={handleMenuClick}>
            {" "}
            Holiday List
          </Link>
        </li>

        <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
            <li
              className={styles.dropdownContainer}
              onClick={openAttendanceDropdown}
            >
              <div
                // onClick={openAttendanceDropdown}
                // style={{
                //   width: "100% !important",
                //   textAlign: "left",
                //   border: "none",
                //   padding: 0,
                //   width: "auto !important",
                // }}
              >
                Attendance Details
              </div>

              <CaretDownOutlined
                style={{
                  transform: `rotate(${isAttendanceOpen ? "180deg" : "0deg"})`,
                  transition: "all 0.3s ease",
                }}
              />
            </li>
            <li>
              {isAttendanceOpen && (
                <div>
                  {attendanceLinks.map((item, index) => {
                    return (
                      <p className={styles.subDropdown} key={index}>
                        <Link to={item.href} onClick={handleMenuClick}>
                          {item.text}
                        </Link>
                      </p>
                    );
                  })}
                </div>
              )}
            </li>
          </ul>

        {`${userRole}` === "Manager" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openDarDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  DAR
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDarOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isDarOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/DarSummary" onClick={handleMenuClick}>
                        DAR Summary
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AddDAR" onClick={handleMenuClick}>
                        DAR Entry
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openQuotationDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Quotation
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${openQuotation ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {openQuotation && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/CreateQuotation" onClick={handleMenuClick}>
                        Create Quotation
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/QuotationList" onClick={handleMenuClick}>
                        Quotation List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/WeeklyActivity" onClick={handleMenuClick}>
                Weekly Activity
              </Link>
            </li>
            {/* <li>
              <Link to="/OrderDefault">Order Processing</Link>
            </li> */}

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReportDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Report
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReportOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReportOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/DailyActivityReport" onClick={handleMenuClick}>
                        Activity Report
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Dar/EmployeesGraph" onClick={handleMenuClick}>
                        Employees Graph
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/PriceList" onClick={handleMenuClick}>
                Price List
              </Link>
            </li>
            <li>
              <Link to="/ReportingHeadConfirmation" onClick={handleMenuClick}>
                Emp Confirmation
              </Link>
            </li>


            {(userData?.loginId === 163 || userData?.loginId === 6) && (
              <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
                <li
                  className={styles.dropdownContainer}
                  onClick={openProjectDropdown}
                >
                  <div
                    style={{
                      width: "100% !important",
                      textAlign: "left",
                      border: "none",
                      padding: 0,
                    }}
                  >
                    Project
                  </div>

                  <CaretDownOutlined
                    style={{
                      transform: `rotate(${isOpenProject ? "180deg" : "0deg"})`,
                      transition: "all 0.3s ease",
                    }}
                  />
                </li>
                {isOpenProject && (
                  <div>
                    {projectLinks.map((item, index) => {
                      return (
                        <p className={styles.subDropdown} key={index}>
                          <Link to={item.href} onClick={handleMenuClick}>
                            {item.text}
                          </Link>
                        </p>
                      );
                    })}
                  </div>
                )}
              </ul>
            )}
            <li>
              <Link to="/Order/Details/List" onClick={handleMenuClick}>
                Order Details
              </Link>
            </li>
            {(userData?.loginId === 163 || userData?.loginId === 6) && (
              <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
                <li>
                  <Link to="/ITEquipment" onClick={handleMenuClick}>
                    IT Equipment Inventory
                  </Link>
                </li>
              </ul>
            )}

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
          </>
        ) : null}
        {/* {`${userRole}` === "User" || `${userRole}` === "Sales" ?  */}

        {`${userRole}` === "User" || `${userRole}` === "Sales" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openDarDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  DAR
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDarOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isDarOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/DarSummary" onClick={handleMenuClick}>
                        DAR Summary
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AddDAR" onClick={handleMenuClick}>
                        DAR Entry
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openQuotationDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Quotation
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${openQuotation ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {openQuotation && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/CreateQuotation" onClick={handleMenuClick}>
                        Create Quotation
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/QuotationList" onClick={handleMenuClick}>
                        Quotation List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/WeeklyActivity" onClick={handleMenuClick}>
                Weekly Activity
              </Link>
            </li>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReportDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Report
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReportOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReportOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/DailyActivityReport" onClick={handleMenuClick}>
                        Activity Report
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Dar/EmployeesGraph" onClick={handleMenuClick}>
                        Employees Graph
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/PriceList" onClick={handleMenuClick}>
                Price List
              </Link>
            </li>

            <li>
              <Link to="/ReportingHeadConfirmation" onClick={handleMenuClick}>
                Emp Confirmation
              </Link>
            </li>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            {probationInfo && probationInfo?.isOnProbation && (
              <li>
                <Link
                  to="/Confirmation/CheckProbation"
                  onClick={handleMenuClick}
                >
                  Probation
                </Link>
              </li>
            )}
            {userData?.loginId !== 6 && userData?.vertical === 3 && (
              <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
                <li
                  className={styles.dropdownContainer}
                  onClick={openProjectActivityDropdown}
                >
                  <div
                    style={{
                      width: "100% !important",
                      textAlign: "left",
                      border: "none",
                      padding: 0,
                    }}
                  >
                    Project Activity
                  </div>

                  <CaretDownOutlined
                    style={{
                      transform: `rotate(${
                        isOpenProjectActivity ? "180deg" : "0deg"
                      })`,
                      transition: "all 0.3s ease",
                    }}
                  />
                </li>
                {isOpenProjectActivity && (
                  <div>
                    {userProjectLinks.map((item, index) => {
                      return (
                        <p className={styles.subDropdown} key={index}>
                          <Link to={item.href} onClick={handleMenuClick}>
                            {item.text}
                          </Link>
                        </p>
                      );
                    })}
                  </div>
                )}
              </ul>
            )}
          </>
        ) : null}

        {`${userRole}` === "Power" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openProjectDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Project Activity
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isOpenProject ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isOpenProject && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Projects/AssignedProject"
                        onClick={handleMenuClick}
                      >
                        Assinged Projects
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Projects/ActivityStatus"
                        onClick={handleMenuClick}
                      >
                        Activity Status
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openTrainingDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Training
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isOpenTraining ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isOpenTraining && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Feedback" onClick={handleMenuClick}>
                        Training Feedback
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Training/Suggestions"
                        onClick={handleMenuClick}
                      >
                        Suggesstions
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Details" onClick={handleMenuClick}>
                        Training Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
          </>
        ) : null}

        {`${userRole}` === "" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openTrainingDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Training
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isOpenTraining ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isOpenTraining && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Feedback" onClick={handleMenuClick}>
                        Training Feedback
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Training/Suggestions"
                        onClick={handleMenuClick}
                      >
                        Suggesstions
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Details" onClick={handleMenuClick}>
                        Training Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
          </>
        ) : null}

        {`${userRole}` === "ISR" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openCustomerMasterDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Customer Master
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isCustomerMasterOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isCustomerMasterOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/CustList" onClick={handleMenuClick}>
                        Customer Master
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/modifyCust" onClick={handleMenuClick}>
                        Add Customer
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openDarDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  DAR
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDarOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isDarOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/DarSummary" onClick={handleMenuClick}>
                        DAR Summary
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AddDar" onClick={handleMenuClick}>
                        DAR Entry
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openQuotDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Quotation
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDarOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isQuotOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/CreateQuotation" onClick={handleMenuClick}>
                        Create Quotation
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/QuotationList" onClick={handleMenuClick}>
                        Quotation List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openOrderDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Order
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isOrderopen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isOrderopen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/OrderDefault" onClick={handleMenuClick}>
                        Order Processing
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Order/Details/List" onClick={handleMenuClick}>
                        Order Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openHRTrainingModuleDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Training
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isHRTrainingmoduleOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isHRTrainingmoduleOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Schedule" onClick={handleMenuClick}>
                        Schedule Training
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Feedback" onClick={handleMenuClick}>
                        Training Feedback
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Training/Suggestions"
                        onClick={handleMenuClick}
                      >
                        Suggesstions
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Details" onClick={handleMenuClick}>
                        Training Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            {probationInfo && probationInfo?.isOnProbation && (
              <li>
                <Link
                  to="/Confirmation/CheckProbation"
                  onClick={handleMenuClick}
                >
                  Probation
                </Link>
              </li>
            )}
          </>
        ) : null}

        {`${userRole}` === "Hr" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li className={styles.dropdownContainer} onClick={openHrDropdown}>
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  HR
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isHrOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isHrOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HR" onClick={handleMenuClick}>
                        Employee Master
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrEmpDesig" onClick={handleMenuClick}>
                        Employee Design
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HREmpDept" onClick={handleMenuClick}>
                        Employee Department
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManageHoliday" onClick={handleMenuClick}>
                        Manage Holiday
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrEmpTargetList" onClick={handleMenuClick}>
                        Employee Target
                      </Link>
                    </li>
                  </p>
           
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HumanResource" onClick={handleMenuClick}>
                        Human Resource
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/HRLeave&latecomingconfirmation"
                        onClick={handleMenuClick}
                      >
                        Employee Confirmation
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openLeaveDetails}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Leave Details
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isLeaveDetailOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isLeaveDetailOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/LeaveDetail/EmployeeLeaveDetail"
                        onClick={handleMenuClick}
                      >
                        Employee Details
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/LeaveDetail/AddNewEmployeeLeave"
                        onClick={handleMenuClick}
                      >
                        Add New Employee
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/LeaveDetail/EmployeesLeaveRecord"
                        onClick={handleMenuClick}
                      >
                        Leave Record
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openAppraisalDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Appraisal
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isAppraisalOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isAppraisalOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/AssignEmployee"
                        onClick={handleMenuClick}
                      >
                        Assign Employee
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/SentReviewForm"
                        onClick={handleMenuClick}
                      >
                        Sent Review Form
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openHRTrainingModuleDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Training
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isHRTrainingmoduleOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isHRTrainingmoduleOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Schedule" onClick={handleMenuClick}>
                        Schedule Training
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Feedback" onClick={handleMenuClick}>
                        Training Feedback
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Training/Suggestions"
                        onClick={handleMenuClick}
                      >
                        Suggesstions
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Details" onClick={handleMenuClick}>
                        Training Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openHrReviewModelDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      ishRreviewModuleOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {ishRreviewModuleOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Appraisal/HrReview" onClick={handleMenuClick}>
                        HR Review
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/HrFinalReview"
                        onClick={handleMenuClick}
                      >
                        HR Final Review
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
          </>
        ) : null}

        {`${userRole}` === "OPU" ? (
          <>
            <li>
              <Link to="/OrderProcessDefault" onClick={handleMenuClick}>
                Order Process
              </Link>
            </li>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/CustomerMaster" onClick={handleMenuClick}>
                Customer Master
              </Link>
            </li>

            <li>
              <Link to="/DAR/ActivityStatus" onClick={handleMenuClick}>
                DAR Activity Status
              </Link>
            </li>
          </>
        ) : null}

        {`${userRole}` === "Director" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openDirectorDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Director Desk
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDirectorOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isDirectorOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/DailyActivityReport" onClick={handleMenuClick}>
                        Activity Report
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrEmployeeList" onClick={handleMenuClick}>
                        Employee
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/CustList" onClick={handleMenuClick}>
                        Customer
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/OrderProcessDefault" onClick={handleMenuClick}>
                        Order Process
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Dar/EmployeesGraph" onClick={handleMenuClick}>
                        Employees Graph
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            {userData?.loginId === 1 && (
              <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
                <li>
                  <Link to="/Appraisal/CeoReview" onClick={handleMenuClick}>
                    CEO Review
                  </Link>
                </li>
              </ul>
            )}
          </>
        ) : null}

        {`${userRole}` === "Administrator" ? (
          <>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openAdminDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Administrative Action
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDirectorOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isAdminOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrEmployeeList" onClick={handleMenuClick}>
                        Employees Master
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AdmPrincipal" onClick={handleMenuClick}>
                        Principal Master
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AdmProduct" onClick={handleMenuClick}>
                        Product Master
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AdmModule" onClick={handleMenuClick}>
                        Module Master
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/HrEmployeeDepartment"
                        onClick={handleMenuClick}
                      >
                        Employee Department
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/HrEmployeeDesignation"
                        onClick={handleMenuClick}
                      >
                        Employee Designation
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrChangePassword" onClick={handleMenuClick}>
                        Change Password
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrChangePassword" onClick={handleMenuClick}>
                        Currency Master
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrChangePassword" onClick={handleMenuClick}>
                        Manage Holidays
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openTargetAndIncentiveDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Target & Incentive
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isDirectorOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isTargetAndIncentiveOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/AdmQuarterMasterList">Quarter Master</Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/AdmPrincipalQuarterNameList"
                        onClick={handleMenuClick}
                      >
                        Principal Quarter Name
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrEmpTargetList" onClick={handleMenuClick}>
                        Employee Target
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/AdmBranchPrincipalTargetList"
                        onClick={handleMenuClick}
                      >
                        Branch Target
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/AdmPrincipalTargetList"
                        onClick={handleMenuClick}
                      >
                        Techlabs Principal Target
                      </Link>
                    </li>
                  </p>

                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/HrEmployeeList" onClick={handleMenuClick}>
                        Employee Target
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openLeaveDetails}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Leave Details
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isLeaveDetailOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isLeaveDetailOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/LeaveDetail/EmployeeLeaveDetail"
                        onClick={handleMenuClick}
                      >
                        Employee Details
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/LeaveDetail/AddNewEmployeeLeave"
                        onClick={handleMenuClick}
                      >
                        Add New Employee
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/LeaveDetail/EmployeesLeaveRecord"
                        onClick={handleMenuClick}
                      >
                        Leave Record
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/ITEquipment" onClick={handleMenuClick}>
                IT Equipment Inventory
              </Link>
            </li>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openOrderDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Order
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isOrderopen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isOrderopen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/OrderDefault" onClick={handleMenuClick}>
                        Order Processing
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Order/Details/List" onClick={handleMenuClick}>
                        Order Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <li>
              <Link to="/Appraisal/AssignEmployee" onClick={handleMenuClick}>
                Appraisal
              </Link>
            </li>
          </>
        ) : null}
     
     {`${userRole}` === "Network" ? (
        <>
          <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
          </ul>
          <li>
              <Link to="/ITEquipment" onClick={handleMenuClick}>
                IT Equipment Inventory
              </Link>
            </li>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openTrainingDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Training
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isOpenTraining ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isOpenTraining && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Feedback" onClick={handleMenuClick}>
                        Training Feedback
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Training/Suggestions"
                        onClick={handleMenuClick}
                      >
                        Suggesstions
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Training/Details" onClick={handleMenuClick}>
                        Training Details
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openKraDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  KRA
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isKraOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isKraOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/MyKRAForm" onClick={handleMenuClick}>
                        My KRA
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/ManagerKRAapproval" onClick={handleMenuClick}>
                        Approve KRA
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReviewDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Review
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${isReviewOpen ? "180deg" : "0deg"})`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReviewOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to={`/${reviewFormLink}`} onClick={handleMenuClick}>
                        My Review Form
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link
                        to="/Appraisal/ManagerAuditEmpList"
                        onClick={handleMenuClick}
                      >
                        Manager Audit
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>

            <ul style={{ width: "100%", padding: 0, listStyle: "none" }}>
              <li
                className={styles.dropdownContainer}
                onClick={openReimbursementDropdown}
              >
                <div
                  style={{
                    width: "100% !important",
                    textAlign: "left",
                    border: "none",
                    padding: 0,
                  }}
                >
                  Reimbursement
                </div>

                <CaretDownOutlined
                  style={{
                    transform: `rotate(${
                      isReimbursementOpen ? "180deg" : "0deg"
                    })`,
                    transition: "all 0.3s ease",
                  }}
                />
              </li>
              {isReimbursementOpen && (
                <div>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement" onClick={handleMenuClick}>
                        Reimbursement
                      </Link>
                    </li>
                  </p>
                  <p className={styles.subDropdown}>
                    <li>
                      <Link to="/Reimbursement/List" onClick={handleMenuClick}>
                        List
                      </Link>
                    </li>
                  </p>
                </div>
              )}
            </ul>
            {probationInfo && probationInfo?.isOnProbation && (
              <li>
                <Link
                  to="/Confirmation/CheckProbation"
                  onClick={handleMenuClick}
                >
                  Probation
                </Link>
              </li>
            )}
        </>
      ) : null}

      </ul>
    </Drawer>
  );
};
export default HeaderSidebar;
